import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import StoreSelector from './StoreSelector'

const useStyles = makeStyles(() => ({
  errorContainer: {
    width: '100%',
    textAlign: 'center'
  }
}))

const ErrorScreen = () => {
  const classes = useStyles()

  return <Grid
    className={classes.errorContainer}
    container
    justify="center"
    direction="row"
    alignContent="center"
    alignItems="center"
  >
    <Grid item xs={10}>
      <h1>Desculpe, houve um erro ao carregar o Cardápio Digital :(</h1>
    </Grid>
    <Grid item xs={12}>
      <StoreSelector/>
    </Grid>
  </Grid>
}

export default ErrorScreen
